<template>
  <div class="d-flex align-center w-full">
    <div class="w-40-porcento d-flex align-center">
      <v-icon size="22" class="mr-1">mdi-format-list-bulleted</v-icon>

      <span class="font-18 font-weight-medium">
        <template v-if="pedido_selecionado.pedido_cli !== 0">
          {{`Pedido exportado: ${ pedido_selecionado.pedido_cli || ''}`}}
        </template>
        <template v-else>Produtos do pedido</template>
      </span>

      <slot name="append-left" />
    </div>

    <div class="w-20-porcento">
      <ConverterEmbalagemPedido :pedido_selecionado="pedido_selecionado" />
    </div>

    <div class="w-40-porcento d-flex">
      <v-spacer />

      <div class="w-400 pb-1 pr-1">
        <v-text-field
          v-model="PESQUISA"
          hide-details
          dense
          clearable
          append-icon="mdi-magnify"
          v-lazy-input:debounce="500"
        >
          <template #label>
            <div class="mt-n2px">Pesquisar</div>
          </template>
        </v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import ConverterEmbalagemPedido from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/ConverterEmbalagemPedido";

export default {
  name: "TopoGrid",
  components: {
    ConverterEmbalagemPedido
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: ['modelValue', 'pedido_selecionado'],
  computed: {
    PESQUISA: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit('update:modelValue', valor);
      }
    }
  }
}
</script>

<style scoped>

</style>
